module.exports = __webpack_public_path__ + "media/images/jumping/promo-felicidad-section-e43b8a80a9a7f6222dbd56a2f28cb00e.jpg";